export default function () {
	return `<img ${this.html.classAttr('page__applicationContractLogo')} src="${this.url.getUrl() + '/assets/img/logo-neustart-kultur.png'}" />`;
}
